import React from "react";
import CheckWorkerInfo from "../../screens/auth/CheckWorkerInfo";
import VStack from "../../ui_atoms/VStack";
import { MockedProvider } from "@apollo/client/testing";
import type { Meta, StoryObj } from "@storybook/react";
import { createStackNavigator } from "@react-navigation/stack";

const Stack = createStackNavigator<{
    CheckWorkerInfo: undefined;
}>();

const StoryComponent = () => {
    return (
        <MockedProvider mocks={[]}>
            <VStack gap={1} style={{ alignItems: "stretch", alignSelf: "stretch", flex: 1 }}>
                <Stack.Navigator initialRouteName="CheckWorkerInfo">
                    <Stack.Screen name="CheckWorkerInfo" component={CheckWorkerInfo} />
                </Stack.Navigator>
            </VStack>
        </MockedProvider>
    );
};

const meta = {
    title: "Screens/Check worker info",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
